<template>
    <div class="flex mb-1">
        <color-picker :opacity="opacity" v-model="color" :initial-color="color"></color-picker>
        <select class="ml-3 form-control form-control-sm" @change="emitInput" v-model="opacity">
            <option :value="trans" v-for="trans in opacities" :key="trans">{{ trans * 100 }} % opacity</option>
        </select>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import ColorPicker from '../ColorPicker';

const props = defineProps({
    defaultValue: Object
});

const emit = defineEmits(['update:modelValue']);

const color = ref(props.defaultValue.color);
const opacity = ref(getOpacity(props.defaultValue.color));
const opacities = [1, .9, .8, .7, .6, .5, .4, .3, .2, .1];

function getOpacity(value) {
    const rgba = parseRgba(value);
    return rgba.a || 1;
}

function parseRgba(value) {
    const results = value.match(/(0?\.?\d{1,3})%?\b/g).map(Number);

    // If we only get #000
    // Fill the rest with the first value, we have
    if (results.length === 1) {
        results.push(results[0], results[0]);
    }
    const [r, g, b, a] = results;
    return { r, g, b, a };
}

function emitInput() {
    emit('update:modelValue', { color: color.value, opacity: opacity.value });
}

watch(color, (newValue) => {
    emit('update:modelValue', { color: newValue });
});

watch(opacity, (newValue) => {
    const rgb = parseRgba(color.value);
    const newColor = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${newValue})`;

    color.value = newColor;

    emit('update:modelValue', { color: newColor });
});

watch(() => props.defaultValue, (newValue) => {
    color.value = newValue.color;
    opacity.value = getOpacity(newValue.color);
});
</script>
